// eslint-disable-next-line import/prefer-default-export
export const POLICY_LINK = "https://ideelgarden.com/policy";

export const NU_LINK = "https://www.frigo.nu/";
